import React from 'react';
import { DialogProps, Dialog } from '@material-ui/core';

export function CommonDialog(props: DialogProps) {
    return (
        <Dialog disableEnforceFocus {...props} />
    );
}
